module.exports = __webpack_public_path__ + "img/picktheanswer.d31efad9.png";